import styled, {css} from 'styled-components'

export const StyledBudgetProjects = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        & > div:first-child {
            padding: ${spacing * 4}px ${spacing * 6}px;
        }
    `
)

export const StyledBudgetProjectsContent = styled.div(
    ({theme: {spacing}}) => css`
        overflow-y: auto;
        display: grid;
        width: 100%;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        grid-template-rows: max-content;
        padding: ${spacing * 4}px ${spacing * 6}px;
        gap: ${spacing * 4}px;
    `
)
